/**
 * Article Content Enhancement
 * Transforms long bullet lists into editorial card-based sections
 * Makes blog articles look more professional and less AI-generated
 */

class ArticleContentEnhancement {
  constructor() {
    this.longListThreshold = 5; // Lists with 5+ items get special treatment
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.enhanceContent());
    } else {
      this.enhanceContent();
    }
  }

  enhanceContent() {
    const articleContent = document.querySelector('.article-template__content.rte');
    if (!articleContent) return;

    // Enhance lists
    this.enhanceLists(articleContent);
    
    // Enhance paragraph flow
    this.enhanceParagraphFlow(articleContent);
  }

  enhanceLists(container) {
    const lists = container.querySelectorAll('ul, ol');
    
    lists.forEach(list => {
      const items = list.querySelectorAll('li');
      const itemCount = items.length;

      // Transform long lists (5+ items) into card-based sections
      if (itemCount >= this.longListThreshold) {
        list.classList.add('article-list--long');
        
        // Add card styling to each item
        items.forEach((item, index) => {
          item.classList.add('article-list-item--card');
          
          // Add subtle animation delay for staggered effect
          if (index < 10) { // Limit to first 10 items for performance
            item.style.setProperty('--animation-delay', `${index * 0.05}s`);
          }
        });

        // Wrap in a container for better grid layout
        if (!list.parentElement.classList.contains('article-list-wrapper')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'article-list-wrapper';
          list.parentNode.insertBefore(wrapper, list);
          wrapper.appendChild(list);
        }
      } else {
        // Short lists get subtle styling
        list.classList.add('article-list--short');
      }
    });
  }

  enhanceParagraphFlow(container) {
    // Add visual breaks between major sections
    const headings = container.querySelectorAll('h2, h3');
    
    headings.forEach((heading, index) => {
      if (index > 0) {
        // Add a subtle visual separator before headings (except first)
        heading.classList.add('article-heading--section');
      }
    });

    // Enhance first paragraph as lead
    const firstParagraph = container.querySelector('p:first-of-type');
    if (firstParagraph && !firstParagraph.classList.contains('article-lead')) {
      firstParagraph.classList.add('article-lead');
    }
  }
}

// Initialize enhancement
if (document.querySelector('.article-template__content')) {
  new ArticleContentEnhancement();
}

// Re-run on dynamic content changes (if using AJAX/SPA)
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        const hasArticleContent = Array.from(mutation.addedNodes).some(
          node => node.nodeType === 1 && 
          (node.classList?.contains('article-template__content') || 
           node.querySelector?.('.article-template__content'))
        );
        
        if (hasArticleContent) {
          new ArticleContentEnhancement();
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}




